export const stages = ['ONBOARDING', 'STAGE 1', 'STAGE 2', 'STAGE 3', 'STAGE 4', 'STAGE 5', 'STAGE 6', 'STAGE 7', 'STAGE 8']

export default stages
